module.exports = __webpack_public_path__ + "img/dll.56aac7e3.svg";